<!-- NOTE: Kendo ListviewheaderTemplate wasn't working as expected -->
<div>
   <samweb-searchbar [searchValue$]="searchValue$" (searchValueChanged)="handleFilterChange($event)">
   </samweb-searchbar>
</div>
<div class="sam-margin">
   <kendo-listview [data]="availableHotkeyTypes" fxFlex="1 1 auto">
      <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
         <samweb-hotkey-setting
            fxFlex="1 1 auto"
            class="dataItem"
            [disabled]="!(isFeatureEnabled$ | async)"
            [shortcutTyp]="dataItem"
            [searchValue$]="searchValue$"
         ></samweb-hotkey-setting>
      </ng-template>
   </kendo-listview>
</div>
